import React from 'react';
import { isEmpty, trim } from 'lodash';
import Modal from 'react-bootstrap/Modal';
import {
  FrameworkAllOption,
  ProgrammingLanguageOption,
  ScenarioConventionOption,
  ScenarioTypeOption,
  TestConventionOption,
  automationToolsMobile,
  automationToolsWebOption,
  automationToolsMobileOption,
  automationToolsWeb,
  startFromOption
} from '../../dataObject/popup';
import { loginPopup as LoginPopup, PrintOptions } from '../../shared/index';
import { FileUploader } from './FileUploader';
import QuillEditor from '../bugCreation/quillEditor';
// import LlmDropdown from './llmDropdown';
// import { loaderViewNew as LoaderViewNew } from '../../shared/loaderViewNew';

export const testDesignView = (props) => {
  const {
    requirementVal,
    requirementValStep2,
    openModalGeneration,
    assessmentAverageScore,
    allImagesData,
    feedbackType,
    feedbackTypeOption,
    feedbackRequirement,
    feedbackDescription,
    feedbackTag,
    feedbackTagOption,
    onChange,
    onCancel,
    isEditorEmpty,
    onCancelStep2,
    onAbort,
    onDone,
    onAnalyze,
    isLoadingStep2,
    openModal,
    showDocError,
    openErrorModal,
    closePopup,
    closeErrorPopup,
    jiraVal,
    openPopup,
    showRequirement,
    testCodeOutput,
    // testCodeOutputWeb,
    showBusiness,
    showStep1Data,
    showStep2Data,
    repoUpload,
    // showDoc,
    onDownloadSave,
    reGenerateCode,
    onChangeRadioButton,
    scenarioConvention,
    scenarioType,
    showStep3Data,
    generatedTest,
    testcases,
    errorMessage,
    apiTitle,
    generateCode,
    gotoStep2Data,
    assessQuality,
    htmllizedTestcases,
    htmlizedTestcases,
    backtostep1,
    configOptionData,
    configId,
    backtostepui1,
    backtostepui2,
    openNewModal,
    closeNewModal,
    jiraCheck,
    backtostep2,
    gotoStep3Data,
    showFinalData,
    isLoading,
    onResponseAccuracy,
    accuracy,
    onUpload,
    submitRequirement,
    requirementRadio,
    imageData,
    handleFile,
    countVal,
    // programmingLanguageVersion,
    programmingLanguage,
    requirementTestRadio,
    requirementAppRadio,
    reGenerateScenario,
    saveAndExit,
    fileName,
    framework,
    startFrom,
    uiframework,
    browsersOrDevices,
    automationTools,
    testConvention,
    isLoadingButton,
    businessRules,
    requirementUnderstanding,
    redirectToAnotherPage,
    showReGenerateData,
    selectedProvider,
    selectedModel,
    handleChangellm,
    llmModels
  } = props;
  let view = null;
  // if (isLoading) {
  //   view = <LoaderViewNew />;
  // } else
  if (errorMessage === 'failure' || errorMessage === 'failureReq' || errorMessage === 'junkerror' || errorMessage === 'junk' || errorMessage === 'junkerr' || errorMessage === 'aborted') {
    view = (
      <div className='superAdmin__container'>
        <Modal
          show={openErrorModal}
          onHide={closeErrorPopup}
          size='sm'
          dialogClassName='modal-10w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Body style={{ padding: '15px 30px' }}>
            <div className='mb-2'>
              <LoginPopup />
            </div>
            <div>{errorMessage === 'aborted' ? 'The step is being aborted and you will be redirected. Please try again later' : errorMessage === 'failure' ? 'There seems to be a problem. Please try again later' : (errorMessage === 'junkerror' || errorMessage === 'junk' || errorMessage === 'junkerr') ? 'Please provide valid requirement details and try again!' : 'There seems to be a problem. Please try again later'}</div>
            <button
              className='btn btn-color mt-3'
              onClick={() => closeErrorPopup(errorMessage)}
            >
              Ok
            </button>
          </Modal.Body>
        </Modal>
      </div>
    );
  } else {
    const disableButton = isEditorEmpty(requirementVal);
    const disableRadio = isEmpty(trim(requirementTestRadio));
    const disableButton1 = isEditorEmpty(requirementValStep2);
    const placeholderText = feedbackType === 'add' ? 'Please provide feedback description for additional test cases...' : feedbackType === 'edit' ? 'Ex: Edit scenario 3 to add database validation...' : feedbackType === 'delete' ? 'Ex: Delete test case 5 no longer valid...' : 'Regenerate using latest business rules and requirement understanding...';
    const disableGenerateButton =
      isEmpty(trim(programmingLanguage)) ||
      isEmpty(trim(framework)) ||
      isEmpty(trim(testcases)) ||
      isEmpty(trim(testConvention));
    const disableGenerateButtonWeb =
      isEmpty(trim(programmingLanguage)) ||
      isEmpty(trim(framework)) ||
      isEmpty(trim(generatedTest)) ||
      isEmpty(trim(testConvention));
    view = (
      <div className='superAdmin__container'>
        <Modal
          show={openModal}
          onHide={closePopup}
          size='m'
          dialogClassName='modal-30w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header closeButton>
            <h5 className='user__heading'>
              Import Requirement From User Story or Document
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className='card login-form'>
              <div className='card-body'>
                <div className='card-text'>
                  <div className='form-group'>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        User Story ID
                      </label>
                      <input
                        type='radio'
                        value='jira'
                        name='requirementRadio'
                        className='form-check-input'
                        defaultChecked={requirementRadio === 'jira'}
                        onChange={(eve) =>
                          onChangeRadioButton('jira', eve, 'requirementRadio')
                        }
                      />
                    </div>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        From Document
                      </label>
                      <input
                        type='radio'
                        value='document'
                        name='requirementRadio'
                        defaultChecked={requirementRadio === 'document'}
                        className='form-check-input'
                        onChange={(eve) =>
                          onChangeRadioButton(
                            'document',
                            eve,
                            'requirementRadio'
                          )
                        }
                      />
                    </div>
                  </div>
                  {requirementRadio === 'jira' ? (
                    <>
                      <div className='form-group mt-2'>
                        <input
                          type='text'
                          name='jiraVal'
                          id='jiraVal'
                          onChange={(eve) =>
                            onChange({
                              id: eve.target.id,
                              value: eve.target.value
                            })
                          }
                          placeholder='Please provide user story id from repo....'
                          value={jiraVal}
                          className={`form-control`}
                        />
                      </div>
                      {/* <div className='row mt-2'>
                        <label className='col-md-3 col-form-label'>
                          ConfigName:
                        </label>
                        <div className='col-md-7'>
                        <select
                      onChange={(eve) =>
                        onChange({
                          id: 'configId',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions value={configId} options={configOptionData} />
                    </select>
                    </div>
                      </div> */}
                    </>
                  ) : (
                    <div>
                      {showDocError ? (
                        <div style={{ color: 'red' }}>
                          *Please upload word(.docx) file
                        </div>
                      ) : (
                        ''
                      )}
                      <div className='form-group mt-2'>
                        <input
                          type='file'
                          name='documentVal'
                          id='documentVal'
                          accept='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
                          className='form-control upload--document'
                          onChange={(eve) => onUpload(eve)}
                        />
                      </div>
                    </div>
                  )}
                  <button
                    type='submit'
                    onClick={() => submitRequirement()}
                    className='btn btn-primary mt-3 user__submit_btn'
                    disabled={isLoadingButton}
                  >
                    Submit
                  </button>
                  {isLoadingButton ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={openModalGeneration}
          onHide={closeNewModal}
          size='lg'
          dialogClassName='modal-30w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header closeButton>
            <h6 className='user__heading'>
              Tell Us How to Enhance Your Test Cases 
            </h6>
          </Modal.Header>
          <Modal.Body>
            <div className='card login-form'>
              <div className='card-body'>
                <div className='card-text'>
                  <div className='form-group row'>
                    <div className='col-sm-5'>
                      Feedback Type:
                    </div>
                    <div className='col-sm-7'>
                      <select
                        onChange={(eve) =>
                          onChange({
                            id: 'feedbackType',
                            value: eve.currentTarget.value
                          })
                        }
                        className='form-select col-sm-6'
                      // disabled={showStep1Data || isLoading}
                      >
                        <PrintOptions value={feedbackType} options={feedbackTypeOption} />
                      </select>
                    </div>
                  </div>
                  {feedbackType === 'customAdd' &&
                    <div className='form-group row mt-3'>
                      <div className='col-sm-5'>
                        Feedback Tags:
                      </div>
                      <div className='col-sm-7'>
                        <select
                          onChange={(eve) =>
                            onChange({
                              id: 'feedbackTag',
                              value: eve.currentTarget.value
                            })
                          }
                          className='form-select'
                        // disabled={showStep1Data || isLoading}
                        >
                          <PrintOptions value={feedbackTag} options={feedbackTagOption} />
                        </select>
                      </div>
                    </div>}
                  <div className='form-group row mt-3'>
                    <div className='col-sm-5'>Feedback Description: <i
                      className='fa fa-info-circle font-custom-css'
                      title={placeholderText}
                    /></div>
                    <div className='col-sm-7'>
                      <textarea
                        className='form-control scrollbar-deep bordered-deep thin col-sm-6'
                        id='feedbackDescription'
                        rows='4'
                        value={feedbackDescription}
                        onChange={(eve) =>
                          onChange({ id: 'feedbackDescription', value: eve.target.value })
                        }
                        placeholder={placeholderText}
                        required
                      />
                    </div>
                  </div>
                  <button
                    type='submit'
                    onClick={() => feedbackRequirement()}
                    className='btn btn-primary mt-3 user__submit_btn'
                    disabled={isLoadingButton || (isEmpty(trim(feedbackDescription))) || (isEmpty(trim(feedbackType)))}
                  >
                    Submit
                  </button>
                  <button
                    onClick={() => closeNewModal()}
                    className='btn btn-primary mt-3 mx-3 user__submit_btn'
                    disabled={isLoadingButton}
                  >
                    Cancel
                  </button>
                  {isLoadingButton ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* <h3 className='heading heading__level2 mb-4'>Parse Requirement</h3> */}
        {requirementTestRadio === 'api' ? <ul className='list-unstyled multi-steps'>
          <li id='firstli' className='is-active' onClick={() => backtostep1()}>
            Requirement
          </li>
          <li id='secondli' className='' onClick={() => backtostep2()}>
            Manual Test Scenario(s)
          </li>
          <li id='thirdli' className=''>
            Automation Test Script(s)
          </li>
        </ul> : <ul className='list-unstyled multi-steps'>
          <li id='firstli' className='is-active' onClick={() => backtostepui1()}>
            Requirement
          </li>
          <li id='secondli' className='' onClick={() => backtostepui2()}>
            Manual Test Scenario(s)
          </li>
          <li id='thirdli' className=''>
            Automation Test Script(s)
          </li>
        </ul>}
        {showRequirement ? (
          <div className='row'>
            <div className='col-lg-6'>
              <div className='mb-3'>
                <div className='row'>
                  <div className='col-md-4 mt-1' title='Choose whether the test is for an API, UI or Mobile'>Application Type : </div>
                  <div className='form-group col-md-5'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'requirementTestRadio',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                      disabled={showStep1Data || isLoading}
                    >
                      <PrintOptions value={requirementTestRadio} options={startFromOption} />
                    </select>
                  </div>
                </div>
                <div className='row mb-2 mt-2'>
                  <div className='mb-2 col-md-4' title='Select if you want to begin from a Requirement, Manual Test Scenario, or Manual Test Case.'>Do you already have Manual Test Cases?: </div>
                  <div className='form-group col-md-7 mt-3'>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        No
                      </label>
                      <input
                        type='radio'
                        value='requirement'
                        name='startFrom'
                        className='form-check-input'
                        disabled={showStep1Data || isLoading || disableRadio}
                        defaultChecked={startFrom === 'requirement'}
                        onChange={(eve) =>
                          onChangeRadioButton('requirement', eve, 'startFrom')
                        }
                      />
                    </div>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        Yes
                      </label>
                      <input
                        type='radio'
                        value='testcases'
                        name='startFrom'
                        defaultChecked={startFrom === 'testcases'}
                        className='form-check-input'
                        disabled={showStep1Data || isLoading || disableRadio}
                        onChange={(eve) =>
                          onChangeRadioButton(
                            'testcases',
                            eve,
                            'startFrom'
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                {(requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && <div className='row'>
                  <div className='mb-3 mt-2 col-md-5'>How do you want to start?: </div>
                  <div className='form-group col-md-7 mt-2 mb-3'>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        New
                      </label>
                      <input
                        type='radio'
                        value='new'
                        name='requirementAppRadio'
                        className='form-check-input'
                        disabled={showStep1Data || isLoading}
                        defaultChecked={requirementAppRadio === 'new'}
                        onChange={(eve) =>
                          onChangeRadioButton('new', eve, 'requirementAppRadio')
                        }
                      />
                    </div>
                    <div className='form-check form-check-inline'>
                      <label className='heading__level5 form-check-label'>
                        Existing
                      </label>
                      <input
                        type='radio'
                        value='existing'
                        name='requirementAppRadio'
                        defaultChecked={requirementAppRadio === 'existing'}
                        className='form-check-input'
                        disabled={showStep1Data || isLoading}
                        onChange={(eve) =>
                          onChangeRadioButton(
                            'existing',
                            eve,
                            'requirementAppRadio'
                          )
                        }
                      />
                    </div>
                  </div>
                </div>}
                {(requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && <div className='row mb-3'>
                  {/* <div className='mt-2 col-sm-5'>{ requirementAppRadio === 'new' ?  'Upload Figma Design' : 'Upload Screen Image' }</div>  */}
                  <div className='mt-2 col-sm-5'>Add Supporting Image: <br /><span style={{ fontSize: '12px', color: '#FF000B' }}>{'Please use ( jpg, png, heic ) image only'}</span></div>
                  <div className='col-sm-3 mt-1'><FileUploader handleFile={handleFile} disableRequirement={showStep1Data} requirementAppRadio={requirementAppRadio} /> </div>
                  {/* <div className='col-sm-4'>{fileName ? <p className='mt-3 mx-1'>{fileName}</p> : null}</div> */}
                  <div className='col-sm-4'>
                    {allImagesData?.length > 0 &&
                      allImagesData.map((img, index) => (
                        <p key={index} className='mt-3 mx-1'>
                          {img.name}
                        </p>
                      ))
                    }
                  </div>
                </div>}
                <div className='heading__level5 mb-2'>{'Requirement Summary & Description: '}</div>
                {/* <div className='heading__level5'>{requirementAppRadio === 'existing' ? 'Provide your requirement: ' : 'Requirement: '}</div> */}
                {/* <textarea
                  className='form-control textarea-height scrollbar-deep bordered-deep thin'
                  id='requirementVal'
                  // rows={(requirementTestRadio === 'web' || requirementTestRadio === 'mobile') ? '9' : '11'}
                  value={requirementVal}
                  disabled={showStep1Data || ((requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && fileName === '') || disableRadio}
                  onChange={(eve) =>
                    onChange({ id: eve.target.id, value: eve.target.value })
                  }
                  placeholder='Paste or write your requirement here. Include title, description, endpoints, request/response, and expected behavior'
                  required
                ></textarea> */}
                 <QuillEditor className="form-control textarea-height scrollbar-deep bordered-deep thin" handleChange={onChange} text={requirementVal} hideToolbar={true} toolbarBottom={false} id='requirementVal' placeholderValue="Paste or write your requirement here. Include title, description, endpoints, request/response, and expected behavior" minHeight="58vh" maxHeight="60vh" />
              </div>
              <div className='row'>
                <div className='wd-28'>
              <button
                className={`btn btn--viewai`}
                onClick={() => openPopup()}
                disabled={showStep1Data || isLoading || disableRadio}
              >
                {'Import Requirement'}
              </button>
              </div>
              <div className='wd-25'>
        {/* <label>Select Model:</label> */}
        <select
          value={`${selectedProvider}|${selectedModel}`}
          onChange={(eve) => handleChangellm(eve)}
          className='form-select'
        >
          {Object.entries(llmModels).map(([provider, models]) => (
            <optgroup key={provider} label={provider.toUpperCase()}>
              {Object.entries(models).map(([key, label]) => (
                <option key={key} value={`${provider}|${key}`}>
                  {label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>

        {/* <div style={{ marginTop: "10px" }}>
          <strong>Selected:</strong> {selectedProvider} - {selectedModel}
        </div> */}
        </div>
            <div className='wd-47'>
              <button
                className={`btn btn--viewai float-end ${disableButton ? 'btn--disabled' : ''
                  }`}
                onClick={() => onDone()}
                disabled={disableButton || isLoading || showStep1Data}
              >
                Enhance Requirement
              </button>
              {isLoading ? (
                <div
                  className='spinner-border spinner-color'
                  id='loaderTestCase'
                ></div>
              ) : (
                ''
              )}
              {!isLoading && <button
                className='btn btn--viewai float-end mx-3'
                onClick={() => onCancel()}
                disabled={disableButton}
              >
                Cancel
              </button>}
              {isLoading && <button
                className='btn btn--viewai float-end mx-3'
                onClick={() => onAbort()}
              >
                Abort
              </button>}
              </div>
              </div>
            </div>
            <div className='col-lg-1'></div>
            {showStep1Data && requirementTestRadio === 'api' && (
              <div className='col-lg-5 mt-4'>
                <div>
                  <h6>API Title:</h6>
                  <p id='apiTitle' className='text-start'>
                    {apiTitle}
                  </p>
                </div>
                <div>
                  <h6>
                    Business Rules{' '}
                    <i
                      className='fa fa-info-circle font-custom-css'
                      title='Please review and revise as needed'
                    />
                  </h6>
                  <textarea
                    className='form-control textarea-height scrollbar-deep bordered-deep thin'
                    id='businessRules'
                    rows='6'
                    value={businessRules}
                    onChange={(eve) =>
                      onChange({ id: eve.target.id, value: eve.target.value })
                    }
                    placeholder='edit your business rules here..'
                    required
                  ></textarea>
                </div>
                <div className='row mt-2 mb-2'>
                  <label
                    htmlFor='scenarioConvention'
                    className='col-sm-4 col-form-label fs-16'
                  >
                    Scenario Convention
                  </label>
                  <div className='col-sm-5'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'scenarioConvention',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions
                        value={scenarioConvention}
                        options={ScenarioConventionOption}
                      />
                    </select>
                  </div>
                </div>
                <div className='row mt-2 mb-2'>
                  <label
                    htmlFor='scenarioType'
                    className='col-sm-4 col-form-label fs-16'
                  >
                    Scenario Type
                  </label>
                  <div className='col-sm-5'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'scenarioType',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions
                        value={scenarioType}
                        options={ScenarioTypeOption}
                      />
                    </select>
                  </div>
                </div>
                <button
                  id='generateTestScenariosBtn'
                  className='btn btn--viewai'
                  disabled={
                    scenarioConvention === '' ||
                    businessRules === '' ||
                    scenarioType === '' ||
                    isLoadingButton
                  }
                  onClick={() => gotoStep2Data()}
                >
                  Generate Test Scenarios
                </button>
                {isLoadingButton ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>
            )}
            {showStep1Data && (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') &&
              <div className='col-lg-5 mt-4'>
                <div>
                  <h6>
                    Requirement Understanding{' '}
                    <i
                      className='fa fa-info-circle font-custom-css'
                      title='Please review and revise as needed'
                    />
                  </h6>
                  <textarea
                    className='form-control textarea-height scrollbar-deep bordered-deep thin'
                    id='requirementUnderstanding'
                    rows='8'
                    value={requirementUnderstanding}
                    onChange={(eve) =>
                      onChange({ id: eve.target.id, value: eve.target.value })
                    }
                    placeholder='Edit your requirement Understanding here..'
                    required
                  ></textarea>
                </div>
                <div className='row mt-2 mb-2'>
                  <label
                    htmlFor='scenarioConvention'
                    className='col-sm-4 col-form-label fs-16'
                  >
                    Scenario Convention
                  </label>
                  <div className='col-sm-5'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'scenarioConvention',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions
                        value={scenarioConvention}
                        options={ScenarioConventionOption}
                      />
                    </select>
                  </div>
                </div>
                <div className='row mt-2 mb-2'>
                  <label
                    htmlFor='scenarioType'
                    className='col-sm-4 col-form-label fs-16'
                  >
                    Scenario Type
                  </label>
                  <div className='col-sm-5'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'scenarioType',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions
                        value={scenarioType}
                        options={ScenarioTypeOption}
                      />
                    </select>
                  </div>
                </div>
                <button
                  id='generateTestScenariosBtn'
                  className='btn btn--viewai'
                  disabled={
                    scenarioConvention === '' ||
                    scenarioType === '' ||
                    isLoadingButton
                  }
                  onClick={() => gotoStep2Data()}
                >
                  Test Scenarios
                </button>
                {isLoadingButton ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>
            }
          </div>
        ) : (
          ''
        )}
        {showBusiness && requirementTestRadio === 'api' && (
          <>
            <div className='row mt-3'>
              <div className="col-md-1"></div>
              {startFrom === 'requirement' ?
                <div className='col-lg-5 mt-4'>
                  <div>
                    <h6>API Title</h6>
                    <p id='apiTitle' className='text-start'>
                      {apiTitle}
                    </p>
                  </div>
                  <div>
                    <h6>
                      Business Rules{' '}
                      <i
                        className='fa fa-info-circle font-custom-css'
                        title='Please review and revise as needed'
                      />
                    </h6>
                    <textarea
                      className='form-control textarea-height scrollbar-deep bordered-deep thin'
                      id='businessRules'
                      rows='6'
                      value={businessRules}
                      disabled={true}
                      onChange={(eve) =>
                        onChange({ id: eve.target.id, value: eve.target.value })
                      }
                      placeholder='edit your business rules here..'
                      required
                    ></textarea>
                  </div>
                  <div className='row mt-2 mb-2'>
                    <label
                      htmlFor='scenarioConvention'
                      className='col-sm-4 col-form-label fs-16'
                    >
                      Scenario Convention
                    </label>
                    <div className='col-sm-5'>
                      <select
                        onChange={(eve) =>
                          onChange({
                            id: 'scenarioConvention',
                            value: eve.currentTarget.value
                          })
                        }
                        className='form-select'
                        disabled={true}
                      >
                        <PrintOptions
                          value={scenarioConvention}
                          options={ScenarioConventionOption}
                        />
                      </select>
                    </div>
                  </div>
                  <div className='row mt-2 mb-2'>
                    <label
                      htmlFor='scenarioType'
                      className='col-sm-4 col-form-label fs-16'
                    >
                      Scenario Type
                    </label>
                    <div className='col-sm-5'>
                      <select
                        onChange={(eve) =>
                          onChange({
                            id: 'scenarioType',
                            value: eve.currentTarget.value
                          })
                        }
                        className='form-select'
                        disabled={true}
                      >
                        <PrintOptions
                          value={scenarioType}
                          options={ScenarioTypeOption}
                        />
                      </select>
                    </div>
                  </div>
                </div> : <div className='col-lg-5 mt-4'>
                  <div className='heading__level5 mb-2'>{'Manual Test Cases Details: '}</div>
                  <textarea
                    className='form-control textarea-height scrollbar-deep bordered-deep thin mb-2'
                    id='requirementValStep2'
                    rows={(requirementTestRadio === 'web' || requirementTestRadio === 'mobile') ? '9' : '11'}
                    value={requirementValStep2}
                    disabled={showStep2Data}
                    onChange={(eve) =>
                      onChange({ id: eve.target.id, value: eve.target.value })
                    }
                    placeholder='Paste your manual testcases details here..'
                    required
                  ></textarea>
                    <div className='row'>
                <div className='wd-28'>
              <button
                    className={`btn btn--viewai`}
                    onClick={() => openPopup()}
                    disabled={showStep2Data || isLoadingStep2}
                  >
                    {'Import Requirement'}
                  </button>
              </div>
              <div className='wd-25'>
        <select
          value={`${selectedProvider}|${selectedModel}`}
          onChange={(eve) => handleChangellm(eve)}
          className='form-select'
        >
          {Object.entries(llmModels).map(([provider, models]) => (
            <optgroup key={provider} label={provider.toUpperCase()}>
              {Object.entries(models).map(([key, label]) => (
                <option key={key} value={`${provider}|${key}`}>
                  {label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
      <div className='wd-47'>
                  <button
                    className={`btn btn--viewai float-end ${disableButton1 ? 'btn--disabled' : ''
                      }`}
                    onClick={() => onAnalyze()}
                    disabled={requirementValStep2 === '' || isLoadingStep2 || showStep2Data}
                  >
                    Enhance Test Scenarios
                  </button>
                  {isLoadingStep2 ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                  {!isLoadingStep2 && <button
                    className='btn btn--viewai float-end mx-3'
                    onClick={() => onCancelStep2()}
                    disabled={requirementValStep2 === ''}
                  >
                    Cancel
                  </button>}
                  {isLoadingStep2 && <button
                    className='btn btn--viewai float-end mx-3'
                    onClick={() => onAbort()}
                  >
                    Abort
                  </button>}
                  </div>
                  </div>
                </div>}
              {startFrom === 'requirement' && <div className='col-md-6 mt-3'>
                <h6>
                  Generated Test Scenarios{' '}
                  <i
                    className='fa fa-info-circle font-custom-css'
                    title='Please review and revise as needed'
                  />
                  <span style={{ float: 'right', fontSize: '14px', color: '#333' }}><i
                    className='fa fa-info-circle font-custom-css mx-2'
                    title='AI-evaluated metric reflecting the overall quality of the generated test case, including correctness, completeness, and readability'
                  />Assessment Quality Score: {assessmentAverageScore}%</span>
                </h6>
                {/* <pre
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                >
                  {testcases}
                </pre> */}
                {/* <pre
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmllizedTestcases }}
                >
                </pre> */}
                <div
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmllizedTestcases }}
                />


                <button
                  id='generateTestCodeBtn'
                  className='btn btn--viewai float-end'
                  disabled={isLoading}
                  onClick={() => gotoStep3Data()}
                >
                  Generate Automation Code
                </button>
                {/* <button
                  className={`btn mx-2 ${accuracy === '' ? 'btn-color' : accuracy <= 50 ? 'btn-red' : accuracy >= '80' ? 'btn-green' : 'btn-amber'}`}
                  disabled={isLoading}
                  onClick={() => onResponseAccuracy()}
                >
                  {accuracy !== '' ? `Response Accuracy:  ${accuracy}%` : 'Response Accuracy'}
                </button> */}
                <button
                  id='regenerateCodeBtn'
                  className='btn btn--viewai mx-2'
                  disabled={isLoading}
                  onClick={() => openNewModal('regenerate')}
                >
                  Regenerate Test Scenarios
                </button>
                {jiraCheck && <button
                  id='generatePushCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('manual')}
                >
                  Push to Repo
                </button>}
                {/* <button
                  id='generateSaveCodeBtn'
                  className='btn btn-color'
                  disabled={isLoading}
                  onClick={() => saveAndExit()}
                >
                  Save & Exit
                </button> */}
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>}
              {showStep2Data && <div className='col-md-6 mt-3'>
                <h6>
                  Generated Test Scenarios{' '}
                  <i
                    className='fa fa-info-circle font-custom-css'
                    title='Please review and revise as needed'
                  />
                </h6>
                <pre
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                >
                  {testcases}
                </pre>
                <button
                  id='generateTestCodeBtn'
                  className='btn btn--viewai float-end'
                  disabled={isLoading}
                  onClick={() => gotoStep3Data()}
                >
                  Generate Automation Code
                </button>
                {/* <button
                  className={`btn mx-2 ${accuracy === '' ? 'btn-color' : accuracy <= 50 ? 'btn-red' : accuracy >= '80' ? 'btn-green' : 'btn-amber'}`}
                  disabled={isLoading}
                  onClick={() => onResponseAccuracy()}
                >
                  {accuracy !== '' ? `Response Accuracy:  ${accuracy}%` : 'Response Accuracy'}
                </button> */}
                {/* <button
                  id='generateSaveCodeBtn'
                  className='btn btn-color'
                  disabled={isLoading}
                  onClick={() => saveAndExit()}
                >
                  Save & Exit
                </button> */}
                {jiraCheck && <button
                  id='generateSaveCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('manual')}
                >
                  Push to Repo
                </button>}
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>}
            </div>
          </>
        )}
        {showBusiness && (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && (
          <>
            <div className='row mt-3'>
              <div className="col-md-1"></div>
              {startFrom === 'requirement' ?
                <div className='col-lg-5 mt-4'>
                  <div>
                    <h6>
                      Requirement Understanding{' '}
                      <i
                        className='fa fa-info-circle font-custom-css'
                        title='Please review and revise as needed'
                      />
                    </h6>
                    <textarea
                      className='form-control textarea-height scrollbar-deep bordered-deep thin'
                      id='requirementUnderstanding'
                      rows='6'
                      value={requirementUnderstanding}
                      disabled={true}
                      onChange={(eve) =>
                        onChange({ id: eve.target.id, value: eve.target.value })
                      }
                      placeholder='edit your business rules here..'
                      required
                    ></textarea>
                  </div>
                  <div className='row mt-2 mb-2'>
                    <label
                      htmlFor='scenarioConvention'
                      className='col-sm-4 col-form-label fs-16'
                    >
                      Scenario Convention
                    </label>
                    <div className='col-sm-5'>
                      <select
                        onChange={(eve) =>
                          onChange({
                            id: 'scenarioConvention',
                            value: eve.currentTarget.value
                          })
                        }
                        className='form-select'
                        disabled={true}
                      >
                        <PrintOptions
                          value={scenarioConvention}
                          options={ScenarioConventionOption}
                        />
                      </select>
                    </div>
                  </div>
                  <div className='row mt-2 mb-2'>
                    <label
                      htmlFor='scenarioType'
                      className='col-sm-4 col-form-label fs-16'
                    >
                      Scenario Type
                    </label>
                    <div className='col-sm-5'>
                      <select
                        onChange={(eve) =>
                          onChange({
                            id: 'scenarioType',
                            value: eve.currentTarget.value
                          })
                        }
                        className='form-select'
                        disabled={true}
                      >
                        <PrintOptions
                          value={scenarioType}
                          options={ScenarioTypeOption}
                        />
                      </select>
                    </div>
                  </div>
                </div> : <div className='col-lg-5 mt-4'>
                  <div className='heading__level5 mb-2'>{'Manual Test Cases Details: '}</div>
                  <textarea
                    className='form-control textarea-height scrollbar-deep bordered-deep thin mb-2'
                    id='requirementValStep2'
                    rows={(requirementTestRadio === 'web' || requirementTestRadio === 'mobile') ? '9' : '11'}
                    value={requirementValStep2}
                    disabled={showStep2Data}
                    onChange={(eve) =>
                      onChange({ id: eve.target.id, value: eve.target.value })
                    }
                    placeholder='Paste your manual testcases details here..'
                    required
                  ></textarea>
                  
                  <div className='row'>
                <div className='wd-28'>
              <button
                    className={`btn btn--viewai`}
                    onClick={() => openPopup()}
                    disabled={showStep2Data || isLoadingStep2}
                  >
                    {'Import Requirement'}
                  </button>
              </div>
              <div className='wd-25'>
        <select
          value={`${selectedProvider}|${selectedModel}`}
          onChange={(eve) => handleChangellm(eve)}
          className='form-select'
        >
          {Object.entries(llmModels).map(([provider, models]) => (
            <optgroup key={provider} label={provider.toUpperCase()}>
              {Object.entries(models).map(([key, label]) => (
                <option key={key} value={`${provider}|${key}`}>
                  {label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
      <div className='wd-47'>
                  <button
                    className={`btn btn--viewai float-end ${disableButton1 ? 'btn--disabled' : ''
                      }`}
                    onClick={() => onAnalyze()}
                    disabled={requirementValStep2 === '' || isLoadingStep2 || showStep2Data}
                  >
                    Enhance Test Scenarios
                  </button>
                  {isLoadingStep2 ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                  {!isLoadingStep2 && <button
                    className='btn btn--viewai float-end mx-3'
                    onClick={() => onCancelStep2()}
                    disabled={requirementValStep2 === ''}
                  >
                    Cancel
                  </button>}
                  {isLoadingStep2 && <button
                    className='btn btn--viewai float-end mx-3'
                    onClick={() => onAbort()}
                  >
                    Abort
                  </button>}
                  </div>
                  </div>
                </div>}
              {startFrom === 'requirement' && <div className='col-md-6 mt-3'>
                <h6>
                  Generated Test Scenarios{' '}
                  <i
                    className='fa fa-info-circle font-custom-css'
                    title='Please review and revise as needed'
                  />
                  <span style={{ float: 'right', fontSize: '14px', color: '#333' }}><i
                    className='fa fa-info-circle font-custom-css mx-2'
                    title='AI-evaluated metric reflecting the overall quality of the generated test case, including correctness, completeness, and readability'
                  />Assessment Quality Score: {assessmentAverageScore}%</span>
                </h6>
                {/* <pre
                  id='generatedTest'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                >
                  {generatedTest}
                </pre> */}
                {/* <pre
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmlizedTestcases }}
                >
                </pre> */}
                <div
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmlizedTestcases }}
                >
                </div>
                <button
                  id='generateTestCodeBtnWeb'
                  className='btn btn--viewai float-end'
                  disabled={isLoading}
                  onClick={() => gotoStep3Data()}
                >
                  Generate Automation Code
                </button>
                {/* <button
                  className={`btn mx-2 ${accuracy === '' ? 'btn-color' : accuracy <= 50 ? 'btn-red' : accuracy >= '80' ? 'btn-green' : 'btn-amber'}`}
                  disabled={isLoading}
                  onClick={() => onResponseAccuracy()}
                >
                  {accuracy !== '' ? `Response Accuracy:  ${accuracy}%` : 'Response Accuracy'}
                </button> */}
                <button
                  id='regenerateCodeBtn'
                  className='btn btn--viewai mx-2'
                  disabled={isLoading}
                  onClick={() => openNewModal('regenerate')}
                >
                  Regenerate Test Scenarios
                </button>
                {jiraCheck && <button
                  id='generateSaveCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('manual')}
                >
                  Push to Repo
                </button>}
                {/* <button
                  id='generateSaveCodeBtn'
                  className='btn btn-color'
                  onClick={() => saveAndExit()}
                >
                  Save & Exit
                </button> */}
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>}
              {showStep2Data && <div className='col-md-6 mt-3'>
                <h6>
                  Generated Test Scenarios{' '}
                  <i
                    className='fa fa-info-circle font-custom-css'
                    title='Please review and revise as needed'
                  />
                </h6>
                <pre
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                >
                  {testcases}
                </pre>
                <button
                  id='generateTestCodeBtn'
                  className='btn btn--viewai float-end'
                  disabled={isLoading}
                  onClick={() => gotoStep3Data()}
                >
                  Generate Automation Code
                </button>
                {/* <button
                  className={`btn mx-2 ${accuracy === '' ? 'btn-color' : accuracy <= 50 ? 'btn-red' : accuracy >= '80' ? 'btn-green' : 'btn-amber'}`}
                  disabled={isLoading}
                  onClick={() => onResponseAccuracy()}
                >
                  {accuracy !== '' ? `Response Accuracy:  ${accuracy}%` : 'Response Accuracy'}
                </button> */}
                {/* <button
                  id='generateSaveCodeBtn'
                  className='btn btn-color'
                  disabled={isLoading}
                  onClick={() => saveAndExit()}
                >
                  Save & Exit
                </button> */}
                {jiraCheck && <button
                  id='generateSaveCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('manual')}
                >
                  Push to Repo
                </button>}
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>}
            </div>
          </>
        )}
        {showFinalData && requirementTestRadio === 'api' && (
          <div className='row mt-3'>
            <div className='col-md-6'>
              <h6>
                Test Scenarios{' '}
                <i
                  className='fa fa-info-circle font-custom-css'
                  title='Please review and revise as needed'
                />
              </h6>
              {startFrom === 'testcases' ? <textarea
                className='form-control textarea-final-height scrollbar-deep bordered-deep thin'
                id='testcases'
                rows='12'
                value={testcases}
                disabled={showReGenerateData}
                onChange={(eve) =>
                  onChange({ id: eve.target.id, value: eve.target.value })
                }
                placeholder='Edit your test scenarios here..'
                required
              ></textarea> :
              <div
                  id='testScenariosOutput'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmllizedTestcases }}
                />
                }
            </div>
            {showStep3Data && showReGenerateData ? (
              <div className='col-lg-6 mt-4'>
                <pre
                  id='testCodeOutput'
                  className='border p-3 scrollbar-deep bordered-deep thin pre-height'
                >
                  {testCodeOutput}
                </pre>
                <button
                  className='btn btn--viewai px-3'
                  onClick={() => onDownloadSave()}
                  disabled={countVal}
                >
                  Save
                </button>
                {jiraCheck && <button
                  id='generateSaveCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('auto')}
                >
                  Push to Repo
                </button>}
                <button
                  className='btn btn--viewai mx-3 px-3'
                  onClick={() => reGenerateCode()}
                >
                  ReGenerate Code
                </button>
                {/* <button
                  className='btn btn--viewai px-3'
                  onClick={() => redirectToAnotherPage()}
                >
                  Exit
                </button> */}
              </div>
            ) : (
              <div className='col-lg-6 mt-4'>
                <div className='mb-3'>
                  <label htmlFor='programmingLanguage' className='form-label'>
                    Programming Language
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'programmingLanguage',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    <PrintOptions
                      value={programmingLanguage}
                      options={ProgrammingLanguageOption}
                    />
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='framework' className='form-label'>
                    Framework
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'framework',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    <PrintOptions value={framework} options={FrameworkAllOption[programmingLanguage] || []} />
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='testConvention' className='form-label'>
                    Test Methodology
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'testConvention',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    <PrintOptions
                      value={testConvention}
                      options={TestConventionOption}
                    />
                  </select>
                </div>
                <button
                  className='btn btn--viewai'
                  onClick={() => generateCode()}
                  disabled={isLoading || disableGenerateButton}
                >
                  Generate Code
                </button>
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        )}
        {showFinalData && (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && (
          <div className='row mt-3'>
            <div className='col-md-6'>
              <h6>
                Test Scenarios{' '}
                <i
                  className='fa fa-info-circle font-custom-css'
                  title='Please review and revise as needed'
                />
              </h6>
              {startFrom === 'testcases' ? <textarea
                className='form-control textarea-final-height scrollbar-deep bordered-deep thin'
                id='generatedTest'
                rows='12'
                value={startFrom === 'testcases' ? testcases : generatedTest}
                disabled={showReGenerateData}
                onChange={(eve) =>
                  onChange({ id: eve.target.id, value: eve.target.value })
                }
                placeholder='Edit your test scenarios here..'
                required
              ></textarea> :
              <div
                  id='generatedTest'
                  className='border p-3 pre-height scrollbar-deep bordered-deep thin'
                  dangerouslySetInnerHTML={{ __html: htmlizedTestcases }}
                >
                </div>}
            </div>
            {showStep3Data && showReGenerateData ? (
              <div className='col-lg-6 mt-4'>
                <pre
                  id='testCodeOutputWeb'
                  className='border p-3 scrollbar-deep bordered-deep thin pre-height'
                >
                  {testCodeOutput}
                </pre>
                {/* <button
                  className='btn btn--viewai px-3'
                  onClick={() => onDownloadSave()}
                  disabled={countVal}
                >
                  Save
                </button> */}
                {jiraCheck && <button
                  id='generateSaveCodeBtn'
                  className='mx-2 btn btn--viewai'
                  disabled={isLoading}
                  onClick={() => repoUpload('auto')}
                >
                  Push to Repo
                </button>}
                <button
                  className='btn btn--viewai mx-3 px-3'
                  onClick={() => reGenerateCode()}
                >
                  ReGenerate Code
                </button>
                {/* <button
                  className='btn btn--viewai px-3'
                  onClick={() => redirectToAnotherPage()}
                >
                  Exit
                </button> */}
              </div>
            ) : (
              <div className='col-lg-6 mt-4'>
                <div className='mb-3'>
                  <label htmlFor='automationTools' className='form-label'>
                    Automation Tools
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'automationTools',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions
                      value={automationTools}
                      options={automationToolsWeb}
                    /> : <PrintOptions
                      value={automationTools}
                      options={automationToolsMobile}
                    />
                    }
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='programmingLanguage' className='form-label'>
                    Programming Language
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'programmingLanguage',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions
                      value={programmingLanguage}
                      options={automationToolsWebOption[automationTools] ? automationToolsWebOption[automationTools].programmingLanguages : []}
                    /> : <PrintOptions
                      value={programmingLanguage}
                      options={automationToolsMobileOption[automationTools] ? automationToolsMobileOption[automationTools].programmingLanguages : []}
                    />}
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='framework' className='form-label'>
                    Framework
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'framework',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions value={framework} options={automationToolsWebOption[automationTools] ? automationToolsWebOption[automationTools].frameworks : []} /> : <PrintOptions value={framework} options={automationToolsMobileOption[automationTools] ? automationToolsMobileOption[automationTools].frameworks : []} />}
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='testConvention' className='form-label'>
                    Test Methodology
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'testConvention',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions
                      value={testConvention}
                      options={automationToolsWebOption[automationTools] ? automationToolsWebOption[automationTools].testConventions : []}
                    /> :
                      <PrintOptions
                        value={testConvention}
                        options={automationToolsMobileOption[automationTools] ? automationToolsMobileOption[automationTools].testConventions : []}
                      />}
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='uiframework' className='form-label'>
                    UI Framework
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'uiframework',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions value={uiframework} options={automationToolsWebOption[automationTools] ? automationToolsWebOption[automationTools].uiFrameworks : []} /> : <PrintOptions value={uiframework} options={automationToolsMobileOption[automationTools] ? automationToolsMobileOption[automationTools].uiFrameworks : []} />}
                  </select>
                </div>
                <div className='mb-3'>
                  <label htmlFor='browsersOrDevices' className='form-label'>
                    Browser/Device
                  </label>
                  <select
                    onChange={(eve) =>
                      onChange({
                        id: 'browsersOrDevices',
                        value: eve.currentTarget.value
                      })
                    }
                    className='form-select'
                  >
                    {requirementTestRadio === 'web' ? <PrintOptions
                      value={browsersOrDevices}
                      options={automationToolsWebOption[automationTools] ? automationToolsWebOption[automationTools].browsersOrDevices : []}
                    /> :
                      <PrintOptions
                        value={browsersOrDevices}
                        options={automationToolsMobileOption[automationTools] ? automationToolsMobileOption[automationTools].browsersOrDevices : []}
                      />}
                  </select>
                </div>
                <button
                  className='btn btn--viewai'
                  onClick={() => generateCode()}
                  disabled={isLoading || disableGenerateButtonWeb}
                >
                  Generate Code
                </button>
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  return <div className='page--superAdmin'>{view}</div>;
};
